const TeCategoriesData = [
    {
      title: "డెవలప్మెంట్",
      subcategories: [
        {
          title: "వెబ్ డెవలప్మెంట్",
          popularTopics: [
            "జావాస్క్రిప్ట్", "రిఅక్ట్", "HTML/CSS", "MERN", "టైప్‌స్క్రిప్ట్", "నోడ్.js", "అంగులార్", "వ్యూ.js", "స్వెల్ట్"
          ]
        },
        {
          title: "మొబైల్ డెవలప్మెంట్",
          popularTopics: [
            "ఫ్లట్టర్", "రిఅక్ట్ నేటివ్", "స్విఫ్ట్", "కోట్‌లిన్", "అండ్రాయిడ్ స్టూడియో", "iOS డెవలప్మెంట్", "జామరిన్", "ఐఓనిక్"
          ]
        },
        {
          title: "ప్రోగ్రామింగ్ భాషలు",
          popularTopics: [
            "పైథాన్", "జావా", "C++", "జావాస్క్రిప్ట్", "గో", "రూబీ", "రస్ట్", "స్విఫ్ట్", "C#", "PHP"
          ]
        },
        {
          title: "గేమ్ డెవలప్మెంట్",
          popularTopics: [
            "యునిటీ", "అనరియల్ ఇంజిన్", "C#", "గేమ్ డిజైన్", "3D మోడలింగ్", "AR/VR డెవలప్మెంట్", "బ్లెండర్", "గోడాట్"
          ]
        },
        {
          title: "డేటాబేస్ డిజైన్ & డెవలప్మెంట్",
          popularTopics: [
            "SQL", "మొంగోDB", "పోస్ట్‌గ్రేస్క్యూల్", "ఫైర్బేస్", "డేటాబేస్ ఆర్కిటెక్చర్", "NoSQL", "GraphQL", "కసాంద్రా"
          ]
        },
        {
          title: "సాఫ్ట్‌వేర్ పరీక్ష",
          popularTopics: [
            "సెలెనియం", "యూనిట్ పరీక్ష", "పరీక్షా ఆటోమేషన్", "API పరీక్ష", "JUnit", "కుకంబర్", "సైప్రస్", "అపియం"
          ]
        },
        {
          title: "సాఫ్ట్‌వేర్ ఇంజనీరింగ్",
          popularTopics: [
            "సాఫ్ట్‌వేర్ డిజైన్ ప్యాటర్న్‌లు", "మైక్రోసర్వీసెస్", "డెవ్‌ఓప్స్", "సిస్టమ్ ఆర్కిటెక్చర్", "అజైల్", "స్క్రం", "CI/CD"
          ]
        },
        {
          title: "సాఫ్ట్‌వేర్ డెవలప్మెంట్ టూల్స్",
          popularTopics: [
            "Git", "డాకర్", "క్యూబర్నెట్స్", "జెన్కిన్స్", "CI/CD", "IDEలు", "టెరాఫార్మ్", "వాగ్రంట్", "గిట్‌ల్యాబ్"
          ]
        },
        {
          title: "నో-కోడ్ డెవలప్మెంట్",
          popularTopics: [
            "వెబ్‌ఫ్లో", "బబుల్", "అడాలో", "జాపియర్", "ఎయిర్‌టేబిల్", "ఇంటిగ్రోమాట్", "గ్లైడ్", "థంకబుల్"
          ]
        }
      ]
    },
    {
      title: "వ్యవసాయం",
      subcategories: [
        {
          title: "సంస్థాపన",
          popularTopics: [
            "స్టార్టప్‌లు", "ఫండింగ్", "వ్యాపార మోడళ్లు", "ఉత్పత్తి నిర్వహణ", "లీన్ స్టార్టప్", "పిచింగ్", "స్కేలింగ్"
          ]
        },
        {
          title: "అమ్మకాలు",
          popularTopics: [
            "B2B అమ్మకాలు", "సమ్మతి", "లీడ్ జనరేషన్", "CRM", "సేల్స్ ఫన్నెల్‌లు", "కోల్డ్ కాలింగ్", "ఇమెయిల్ మార్కెటింగ్"
          ]
        },
        {
          title: "నాయకత్వం & నిర్వహణ",
          popularTopics: [
            "టీమ్ నిర్వహణ", "నాయకత్వ నైపుణ్యాలు", "అజైల్ నాయకత్వం", "సాంకేతిక ఆలోచన", "ప్రాజెక్ట్ నిర్వహణ", "OKRs"
          ]
        },
        {
          title: "వ్యాపార విశ్లేషణ",
          popularTopics: [
            "డేటా విశ్లేషణ", "పవర్ BI", "టేబ్లో", "ఫైనాన్షియల్ మోడలింగ్", "వ్యాపార బుద్ధి", "డేటా విజువలైజేషన్", "Excel"
          ]
        }
      ]
    },
    {
      title: "ఆర్థిక & ఖాతా",
      subcategories: [
        {
          title: "ఆర్థిక ఖాతా",
          popularTopics: [
            "బ్యాలెన్స్ షీట్స్", "ఆయ నామాలు", "GAAP", "IFRS", "ఆడిటింగ్", "బుక్‌కీపింగ్", "పన్నులు", "క్విక్‌బుక్‌లు"
          ]
        },
        {
          title: "కార్పొరేట్ ఆర్థిక",
          popularTopics: [
            "ధన బడ్జెట్", "కార్పొరేట్ అంచనా", "రిస్క్ మేనేజ్మెంట్", "మర్జర్స్ & అక్విజిషన్స్", "నివేశ బ్యాంకింగ్", "IPO"
          ]
        },
        {
          title: "వ్యక్తిగత ఆర్థిక",
          popularTopics: [
            "బడ్జెట్ చేయడం", "బచత", "నివేశాలు", "రిటైర్మెంట్ ప్రణాళిక", "ఆర్థిక స్వాతంత్ర్యం", "రియల్ ఎస్టేట్", "స్టాక్స్"
          ]
        }
      ]
    },
    {
      title: "IT & సాఫ్ట్‌వేర్",
      subcategories: [
        {
          title: "క్లౌడ్ కంప్యూటింగ్",
          popularTopics: [
            "AWS", "అజ్యూర్", "గూగుల్ క్లౌడ్", "క్యూబర్నెట్స్", "సర్వర్‌లెస్ ఆర్కిటెక్చర్", "క్లౌడ్ సెక్యూరిటీ", "డెవ్‌ఓప్స్", "ఓపెన్‌షిఫ్ట్"
          ]
        },
        {
          title: "సైబర్‌సెక్యూరిటీ",
          popularTopics: [
            "నైతిక హ్యాకింగ్", "పెనిట్రేషన్ పరీక్ష", "నెట్‌వర్క్ సెక్యూరిటీ", "క్రిప్టోగ్రఫీ", "సైబర్ బెదిరింపులు", "ఫైర్‌వాళ్‌లు", "SOC"
          ]
        },
        {
          title: "నెట్‌వర్కింగ్",
          popularTopics: [
            "CCNA", "నెట్‌వర్క్ ప్రోటోకాల్‌లు", "సిస్కో", "SDN", "నెట్‌వర్క్ సెక్యూరిటీ", "రౌటింగ్", "VPN", "స్విచ్"
          ]
        }
      ]
    },
    {
      title: "డిజైన్",
      subcategories: [
        {
          title: "గ్రాఫిక్ డిజైన్",
          popularTopics: [
            "ఫోటోషాప్", "ఇలస్ట్రేటర్", "ఇన్‌డిజైన్", "కాన్వా", "టైపోగ్రఫీ", "రంగు సిద్ధాంతం", "లోగో డిజైన్", "బ్రాండింగ్"
          ]
        },
        {
          title: "UI/UX డిజైన్",
          popularTopics: [
            "ఫిగ్మా", "అడోబ్ XD", "స్కెచ్", "వైర్ఫ్రేమింగ్", "ప్రోటోటైపింగ్", "ఉపయోగదారు పరిశోధన", "ఉపయోగిత పరీక్ష"
          ]
        },
        {
          title: "3D & యానిమేషన్",
          popularTopics: [
            "బ్లెండర్", "మాయ", "3ds మాక్స్", "సినిమా 4D", "ఆఫ్టర్ ఇఫెక్ట్స్", "మోషన్ గ్రాఫిక్స్", "క్యారెక్టర్ యానిమేషన్"
          ]
        }
      ]
    },
    {
      title: "మార్కెటింగ్",
      subcategories: [
        {
          title: "డిజిటల్ మార్కెటింగ్",
          popularTopics: [
            "SEO", "గూగుల్ యాడ్స్", "ఫేస్‌బుక్ యాడ్స్", "కంటెంట్ మార్కెటింగ్", "సోషల్ మీడియా మార్కెటింగ్", "PPC", "ఇన్ఫ్లుఎన్సర్ మార్కెటింగ్"
          ]
        },
        {
          title: "అఫిలియేట్ మార్కెటింగ్",
          popularTopics: [
            "అఫిలియేట్ నెట్‌వర్క్‌లు", "కమీషన్ ట్రాకింగ్", "ఉత్పత్తి సమీక్షలు", "అఫిలియేట్‌ల కోసం SEO", "ఇమెయిల్ క్యాంపెయిన్‌లు"
          ]
        },
        {
          title: "బ్రాండింగ్",
          popularTopics: [
            "బ్రాండ్ వ్యూహం", "బ్రాండ్ గుర్తింపు", "బ్రాండ్ ధ్వని", "గ్రాహక నిమగ్నత", "పునర్నిర్మాణం", "PR", "కథన"
          ]
        }
      ]
    }
  ];
  
  export default TeCategoriesData;
  